type callback = (args: { message: string; origin: string | undefined; } | { error: number; }) => void;
export type MddDialogEventHandlers = {
    onClose?: (() => void);
    onUrlError: () => void;
    onUnknownError: () => void;
} | null;

export const processDialogEvent = (dialog, arg, eventHandlers: MddDialogEventHandlers = null) => {
    dialog.close();
    debugger
    switch (arg.error) {
        case 12002:
            showNotification("The URL provided is not available.");
            eventHandlers?.onUrlError && eventHandlers.onUrlError();
            break;
        case 12003:
            showNotification("The dialog box has been directed to a URL with the HTTP protocol. HTTPS is required.");
            eventHandlers?.onUrlError && eventHandlers.onUrlError();
            break;
        case 12006:
            showNotification("Dialog closed.");
            eventHandlers?.onClose && eventHandlers.onClose();
            break;
        default:
            showNotification("Unknown error in dialog box.");
            eventHandlers?.onUnknownError && eventHandlers.onUnknownError();
            break;
    }
}

const showNotification = (message: string) => {
    console.error(message);
    // todo: dispaly error when toast/alt implemented
}

export const openDialog = (url: string, options: Office.DialogOptions, callback: callback, eventHandlers: MddDialogEventHandlers = null): Promise<Office.Dialog> => {
    return new Promise<Office.Dialog>((resolve, reject) => {
        let dialog: Office.Dialog;
        Office.context.ui.displayDialogAsync(url, options, (result: Office.AsyncResult<Office.Dialog>) => {
            if (result.status === Office.AsyncResultStatus.Succeeded) {
                dialog = result.value;
                dialog.addEventHandler(Office.EventType.DialogEventReceived, (arg) => processDialogEvent(dialog, arg, eventHandlers));
                dialog.addEventHandler(
                    Office.EventType.DialogMessageReceived, callback
                );
                resolve(dialog);
            } else {
                console.error(`Error opening the login dialog. ${result.error.message}.`);
                reject(result.error);
            }
        });
    });
}